export enum GameState { // eslint-disable-line no-shadow
  Loading,
  Paused,
  Started,
  Over
}
